// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseImage from 'shared/components/ImageV2';

// constants
import {
  BASE_GUTTER_SPACE,
  BREAKPOINTS,
  HIDE_SCROLLBARS,
  HORIZONTAL_SCROLLBARS,
} from 'shared/styles/base';

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
export const TagsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100vw;
  margin-left: ${({ theme }) => `-${theme.spacing.spacing80}`};

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${HIDE_SCROLLBARS}
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-left: 0;
    padding-bottom: ${({ theme }) => theme.spacing.spacing60};
    ${HORIZONTAL_SCROLLBARS}
    max-width: 100%;
  }
`;
export const Tag = styled.div<{ width: number }>`
  min-width: ${({ width }) => `${width}%`};
  width: ${({ width }) => `${width}%`};
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  border-radius: ${({ theme }) => theme.borders.radius10};
  margin-right: ${({ theme }) => theme.spacing.spacing40};

  :first-of-type {
    margin-right: ${({ theme }) => theme.spacing.spacing80};

    @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
      margin-left: 0px;
    }
  }

  :last-of-type {
    margin-right: ${({ theme }) => theme.spacing.spacing80};

    @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
      margin-right: 0px;
    }
  }
`;

export const ImageContainer = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.responsibleTagBg};

  margin: ${({ theme }) => `${theme.spacing.spacing60} auto ${theme.spacing.spacing40} auto`};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
`;

export const Image = styled(BaseImage)<{ maxWidth: number; height: number }>`
  object-fit: contain;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Label = styled.p`
  ${({ theme }) => theme.typography.bodySmall};
  margin: 0 ${BASE_GUTTER_SPACE}px ${BASE_GUTTER_SPACE * 1.5}px ${BASE_GUTTER_SPACE}px;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;
